var _path, _path2, _path3, _path4, _path5, _path6, _path7, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCtflixLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 159,
    height: 29,
    viewBox: "0 0 159 29",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M76.5582 18.7877H80.8887C80.813 20.5286 80.4562 22.0045 79.8182 23.2156C79.1911 24.4158 78.2882 25.3295 77.1096 25.9566C75.9418 26.5838 74.52 26.8973 72.844 26.8973C71.5681 26.8973 70.4273 26.6757 69.4217 26.2323C68.4161 25.7782 67.5619 25.124 66.8591 24.2698C66.1671 23.4156 65.6372 22.3668 65.2696 21.1233C64.9128 19.869 64.7344 18.4363 64.7344 16.8252V12.7217C64.7344 11.1106 64.9236 9.67794 65.302 8.42366C65.6805 7.16938 66.2211 6.10972 66.924 5.2447C67.6376 4.37967 68.5026 3.7255 69.519 3.28217C70.5354 2.83885 71.6816 2.61719 72.9575 2.61719C74.6443 2.61719 76.0554 2.93616 77.1907 3.57412C78.3261 4.21208 79.2019 5.14738 79.8182 6.38004C80.4346 7.60189 80.7968 9.09405 80.9049 10.8565H76.5744C76.5311 9.71038 76.3906 8.80211 76.1527 8.13171C75.9148 7.45051 75.5418 6.96393 75.0336 6.67199C74.5254 6.38004 73.8333 6.23407 72.9575 6.23407C72.2763 6.23407 71.687 6.35842 71.1896 6.60711C70.6922 6.8558 70.2867 7.24506 69.9732 7.77489C69.6596 8.29391 69.4271 8.95889 69.2757 9.76985C69.1244 10.5808 69.0487 11.554 69.0487 12.6893V16.8252C69.0487 17.9173 69.1136 18.8688 69.2433 19.6798C69.3731 20.4907 69.5785 21.1665 69.8596 21.7072C70.1516 22.237 70.5408 22.6371 71.0274 22.9074C71.514 23.1669 72.1195 23.2967 72.844 23.2967C73.7198 23.2967 74.4172 23.1669 74.9362 22.9074C75.4553 22.6371 75.8391 22.1775 76.0878 21.5288C76.3473 20.8692 76.5041 19.9555 76.5582 18.7877Z",
    fill: "url(#paint0_linear_2178_782)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M92.5827 2.95779V26.5729H88.2684V2.95779H92.5827ZM98.5352 2.95779V6.59089H82.4133V2.95779H98.5352Z",
    fill: "url(#paint1_linear_2178_782)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M105.818 2.95779V26.5729H101.471V2.95779H105.818ZM113.343 13.1272V16.7441H104.763V13.1272H113.343ZM114.349 2.95779V6.59089H104.763V2.95779H114.349Z",
    fill: "url(#paint2_linear_2178_782)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M130.244 22.9561V26.5729H120.431V22.9561H130.244ZM121.68 2.95779V26.5729H117.333V2.95779H121.68Z",
    fill: "url(#paint3_linear_2178_782)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M137.705 2.95779V26.5729H133.39V2.95779H137.705Z",
    fill: "url(#paint4_linear_2178_782)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M146.025 2.95779L149.658 11.116L153.145 2.95779H157.995L152.188 14.6518L158.108 26.5729H153.097L149.463 18.2525L145.847 26.5729H140.932L146.917 14.5707L141.062 2.95779H146.025Z",
    fill: "url(#paint5_linear_2178_782)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M46.1132 2.67823C44.5919 0.976103 42.4144 0 40.1385 0H8.02735C5.75147 0 3.57393 0.976103 2.05267 2.67823C0.535415 4.37835 -0.197121 6.65928 0.0457199 8.93416L1.34622 21.0346C1.78775 25.1387 5.21963 28.2344 9.32785 28.2344H13.426C16.4104 28.2344 19.1298 26.5887 20.5246 23.9367L22.5516 20.0787C22.9912 19.2437 23.7658 19.153 24.0789 19.153C24.392 19.153 25.1687 19.2437 25.6082 20.0787L27.6352 23.9347C29.0301 26.5847 31.7495 28.2324 34.7338 28.2324H38.834C42.9422 28.2324 46.3741 25.1367 46.8156 21.0326L48.1181 8.93215C48.363 6.65928 47.6304 4.37835 46.1112 2.67622L46.1132 2.67823ZM5.04101 5.3726C5.81168 4.50943 6.87336 4.03348 8.02735 4.03348H14.0482V6.05022C14.0482 7.16145 13.1471 8.06696 12.0412 8.06696H4.03553C4.03352 7.07271 4.36869 6.12484 5.04101 5.3726ZM44.1283 8.50258L42.8258 20.603C42.6051 22.6561 40.8891 24.2029 38.836 24.2029H34.7358C33.2426 24.2029 31.8839 23.3801 31.1855 22.0531L29.1585 18.1971C28.161 16.3013 26.2163 15.1215 24.0809 15.1215C21.9475 15.1215 20.0008 16.2993 19.0033 18.195L16.9763 22.0531C16.2799 23.3781 14.9192 24.2009 13.428 24.2009H9.32986C7.27675 24.2009 5.56081 22.652 5.33804 20.601L4.42287 12.1004H12.0392C15.3587 12.1004 18.0601 9.38591 18.0601 6.05022V4.03348H40.1365C41.2925 4.03348 42.3522 4.50943 43.1248 5.3726C43.8955 6.23576 44.2528 7.349 44.1283 8.50258Z",
    fill: "url(#paint6_linear_2178_782)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2178_782",
    x1: 67.5607,
    y1: 14.7573,
    x2: 130.385,
    y2: 53.692,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F68475"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.275,
    stopColor: "#FCEC9C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.535,
    stopColor: "#FF7A54"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.765,
    stopColor: "#B1CAEF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A3FFD1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_2178_782",
    x1: 67.5607,
    y1: 14.7573,
    x2: 130.385,
    y2: 53.692,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F68475"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.275,
    stopColor: "#FCEC9C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.535,
    stopColor: "#FF7A54"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.765,
    stopColor: "#B1CAEF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A3FFD1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_2178_782",
    x1: 67.5607,
    y1: 14.7573,
    x2: 130.385,
    y2: 53.692,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F68475"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.275,
    stopColor: "#FCEC9C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.535,
    stopColor: "#FF7A54"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.765,
    stopColor: "#B1CAEF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A3FFD1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_2178_782",
    x1: 67.5607,
    y1: 14.7573,
    x2: 130.385,
    y2: 53.692,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F68475"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.275,
    stopColor: "#FCEC9C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.535,
    stopColor: "#FF7A54"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.765,
    stopColor: "#B1CAEF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A3FFD1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_2178_782",
    x1: 67.5607,
    y1: 14.7573,
    x2: 130.385,
    y2: 53.692,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F68475"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.275,
    stopColor: "#FCEC9C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.535,
    stopColor: "#FF7A54"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.765,
    stopColor: "#B1CAEF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A3FFD1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_2178_782",
    x1: 67.5607,
    y1: 14.7573,
    x2: 130.385,
    y2: 53.692,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F68475"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.275,
    stopColor: "#FCEC9C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.535,
    stopColor: "#FF7A54"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.765,
    stopColor: "#B1CAEF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A3FFD1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_2178_782",
    x1: 1.45789,
    y1: 14.1172,
    x2: 43.1591,
    y2: 25.5811,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F68475"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.275,
    stopColor: "#FCEC9C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.535,
    stopColor: "#FF7A54"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.765,
    stopColor: "#B1CAEF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A3FFD1"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCtflixLogo);
export default __webpack_public_path__ + "static/media/ctflix-logo.49f16cfefec2c6aa52c636ad8574687a.svg";
export { ForwardRef as ReactComponent };